<script setup lang="ts">
// shared
import Home from "@/shared/components/atomic/svgs/home/Home.vue";

// entities
import useAuthenticationStore from "@/entities/user/infrastructure/userStore";

// instance
const authenticationStore = useAuthenticationStore();
</script>

<template>
    <div class="flex gap-3 justify-center items-center bg-white p-xsmall">
        <Home />
        <p class="font-bold text-t-primary text-body-medium font-pretendard">
            {{ authenticationStore.academyName }}
        </p>
    </div>
</template>
